module.exports = __webpack_public_path__ + "e438bd2c3f6a841a767ec76a851b8963.fbx";